export default __webpack_public_path__ + "static/media/flag_gray.28ab38b7.svg";